import { forceMaterialDesignMode } from './materialMode.ts'
import { isCapacitorNative } from '../api/ZionServer.ts'
import { isStandalonePwa } from './router.ts'

export type AppLayoutMode = 'chat' | 'page'

const APP_LAYOUT_INLINE_KEYS = [
  'position',
  'left',
  'right',
  'top',
  'bottom',
  'width',
  'max-width',
  'height',
  'max-height',
  'margin',
  'transform',
  'flex',
] as const

/** Rimuove stili inline di layout su #app (il CSS gestisce chat/home). */
export function clearAppLayoutInlineStyles(app: HTMLElement): void {
  for (const key of APP_LAYOUT_INLINE_KEYS) {
    app.style.removeProperty(key)
  }
}

/** Allinea classi body/#app alla schermata corrente — evita contenuto “sparito” dopo la chat. */
export function applyAppLayout(mode: AppLayoutMode): void {
  const app = document.querySelector<HTMLElement>('#app')
  if (!app) return
  const chat = mode === 'chat'
  app.classList.toggle('screen-chat', chat)
  document.documentElement.classList.toggle('chat-active', chat)
  document.body.classList.toggle('chat-active', chat)
  clearAppLayoutInlineStyles(app)
}

export function isAppleDevice(): boolean {
  const ua = navigator.userAgent
  return (
    /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  )
}

/**
 * Classi device + Material Design forzato su iOS/iPad.
 * Non aggiungere `html.ios` per lo stile: altererebbe layout rispetto ad Android.
 * `apple-device` è solo capability (es. file picker), non tema Cupertino.
 * `capacitor-native` nasconde banner PWA e allinea safe-area composer.
 */
export function initDeviceClasses(): void {
  forceMaterialDesignMode()

  const root = document.documentElement
  if (isCapacitorNative()) {
    root.classList.add('capacitor-native', 'md', 'plt-md', 'md-mode')
    root.classList.remove('ios', 'ios-mode', 'plt-ios', 'vault-ui')
    root.dataset.runtime = 'capacitor'
  }
  root.classList.remove('vault-ui')
  if (isAppleDevice()) {
    root.classList.add('apple-device')
    root.dataset.platform = 'ios'
  } else if (/Android/i.test(navigator.userAgent)) {
    root.dataset.platform = 'android'
  } else {
    root.dataset.platform = 'web'
  }
  if (window.matchMedia('(pointer: coarse)').matches) {
    root.classList.add('touch')
  }
  if (!isCapacitorNative() && !isStandalonePwa()) {
    root.classList.add('web-browser')
  } else {
    root.classList.remove('web-browser')
  }
  if (isStandalonePwa()) {
    root.classList.add('pwa-standalone')
  } else {
    root.classList.remove('pwa-standalone')
  }
}
